export default __webpack_public_path__ + "static/dog-sad-cfd2da37a7685febb2e21f90106725bd.svg";